import { CONFIG } from "./globalConfig";

const env = {};
const PROD = true;
const URL = PROD ? CONFIG.DOMAIN : "http://localhost";
const PORT = CONFIG.APP_PORT || 1337;
env.url = URL;
env.port = PORT;
env.apiUrl = `${URL}:${PORT}/api/v1`;
env.appName = CONFIG.APP_NAME;
env.version = CONFIG.VERSION;
export default env;
